import { ReactNode } from 'react';
import { Modal, Button } from 'react-bootstrap';
type ConfirmationModalProps = {
  show: boolean;
  title?: ReactNode;
  body?: ReactNode;
  children?: ReactNode;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
  confirmVariant?: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'light' | 'dark' | string;
  cancelVariant?: 'secondary' | string;
  disableConfirm?: boolean;
  backdrop?: true | false | 'static';
  centered?: boolean;
};
const ConfirmationModal = ({
  show,
  title = 'Are you sure?',
  body,
  children,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  onConfirm,
  onCancel,
  confirmVariant = 'primary',
  cancelVariant = 'secondary',
  disableConfirm = false,
  backdrop = 'static',
  centered = true,
}: ConfirmationModalProps) => {
  return (
    <Modal show={show} onHide={onCancel} backdrop={backdrop} centered={centered} restoreFocus>
      {' '}
      {title && (
        <Modal.Header closeButton>
          {' '}
          <Modal.Title>{title}</Modal.Title>{' '}
        </Modal.Header>
      )}{' '}
      <Modal.Body>{children ?? body}</Modal.Body>{' '}
      <Modal.Footer>
        {' '}
        <Button variant={cancelVariant} onClick={onCancel}>
          {' '}
          {cancelText}{' '}
        </Button>{' '}
        <Button variant={confirmVariant} onClick={onConfirm} disabled={disableConfirm}>
          {' '}
          {confirmText}{' '}
        </Button>{' '}
      </Modal.Footer>{' '}
    </Modal>
  );
};
export default ConfirmationModal;
